(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    //  If a printer is present, then use test on 1 printer flow 
    //  If no printer is present, then use test on * printers flow

  function pxGoCredentialTest(
    $http
  ) {
    return {
      restrict: 'EA',
      scope: {
        context: '=context',
        tenant: '=tenant',
        printer: '=printer',
        meta: '=meta',
        callback: '&callback'
      },
      templateUrl: 'app/components/onDeviceConfigProperties/goCredentialTest/goCredentialTest.template.html',
      link: function(scope) {

        scope.gettingPrinterGoProfile = true;
        scope.printerHasGoProfile = false;

        (function() {
          if (scope.printer) {
            getSignInProfile();  
          }
        })();

        function getSignInProfile () {
          var url = scope.printer.info._links['px:printerCredential'].href;
          $http.get(url).then(function(response) {
            scope.printerGoProfile = response.data;
            scope.gettingPrinterGoProfile = false;
            scope.printerHasGoProfile = true;
          }).catch(function(error) {
            scope.gettingPrinterGoProfile = false;
            scope.printerHasGoProfile = false;
          });
        }

        scope.$on('$destroy', function() {
        });


      }
    };
  }

  pxGoCredentialTest.$inject = ['$http'];

  angular
    .module('printix-admin')
    .directive('pxGoCredentialTest', pxGoCredentialTest);

})();
